<template>
  <div>
    <img src="https://www.tssgroup.com.cn/style/images/about_01.jpg?v=1" style="width:100%;height: 120px;position: fixed;top: 0;left: 0;z-index: 999">

    <div class="container">
      <div class="inContainer">
        <h3 style="text-align: left;
                  color: #2e5c9a;
                  font-size: 18px;
                  margin-bottom: 10px;
                  font-weight: bold;">青山实业廉洁举报须知</h3>
        <p class="content"><b>一、阳光政策</b></p>
        <p class="content">1. 举报保密政策</p>
        <p class="content">2. 实名优先政策</p>
        <p class="content">3. 查实有奖政策</p>
        <p class="content"><b>二、受理范围</b></p>
        <div class="content">1. 索取或收受贿赂</div>
        <div class="content">2. 违规收受礼品或招待</div>
        <div class="content">3. 挪用或侵占公司资产</div>
        <div class="content">4. 利用职权谋取私利</div>
        <div class="content">5. 虚假报销</div>
        <div class="content">6. 违规参股、经营等损害公司利益</div>
        <div class="content">7. 滥用职权或玩忽职守</div>
        <div class="content">8. 侵犯商业秘密</div>
        <div class="content">9. 违规招投标</div>
        <div class="content">10. 其他违法违纪行为</div>
        <p class="content"><b>三、特别提醒</b></p>
        <p class="content">举报人应对举报事项的真实性负责。对捏造事实，借举报诬告陷害的，我们将保留对举报者采取法律手段和纪律处分的权利。</p>
        <br>
        <div style="text-align: center;width: 100px;  background: #003677;margin-left: 35%">
          <p class="footerBtn" style="padding: 10px 30px;
                                      background: #2e5c9a;
                                      color: #fff;
                                      font-size: 14px;
                                      cursor: pointer;" @click="toForm" >确 定</p>
        </div>
      </div>
    </div>
<!--    <div style="width: 100%;height: 10px">-->

<!--    </div>-->
<!--    <div class="footer" @click="dialogVisible = true">-->
<!--       <p class="footerBtn" >我 要 举 报</p>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return{
      dataList:[
        {title:"举报保密政策",content:"我们将严格保守举报人身份信息及举报内容，严格管控调查流程，依法保障举报人合法权益，严肃处理打击报复者。"},
        {title:"实名优先政策",content:"我们鼓励举报人提供个人真实姓名及联系方式，尊重举报人的选择。对实名举报者，我们将优先受理并及时反馈处理结果。"},
        {title:"查实有奖政策",content:"凡实名举报且经查证属实的，我们将综合赃款赃物追回等情况，给予举报人最高1000万元人民币的奖励。"},
      ],
      bannerwidth: 0,        //轮播图宽度
      StartPoint: 0,         //触摸开始的点的横坐标
      EndPoint: 0,           //触摸结束的点的横坐标
      MoveLength: 0,         //StartPoint与EndPoint的差值
      CurrentImg: 0,         //当前轮播图的索引
      isPlaying: true,       //判断是否处于自动轮播
      playTimer: null,        //轮播定时器
      dialogVisible: false
    }
  },
  mounted() {
    //页面挂在完毕自动开启轮播
    // this.startPlay()
  },
  methods:{
    handleClose(done) {
      this.dialogVisible = false;
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    toForm(){
      this.$router.push({ name:'PcForm'})
    },
    TouchStart(event){
      //停止轮播
      clearInterval(this.playTimer)
      //获取触摸的开始点
      this.StartPoint = event.changedTouches[0].pageX
    },
    TouchMove(event){
      //获取触摸的结束点
      this.EndPoint = event.changedTouches[0].pageX
      this.slidings()
    },
    TouchEnd(){
      this.Jump()
      //开始轮播
      this.startPlay()
    },
    //Jump()方法用于处理滑动到一定程度后松手自动跳转到下一页或上一页
    Jump(){
      const currentimg = document.getElementsByClassName('slide')
      //滑动超过轮播图宽度的百分之40，则跳转下一张，否则不跳转
      if(this.MoveLength > 0 && this.CurrentImg !== this.dataList.length-1){
        if(this.MoveLength > this.bannerwidth * 0.4){
          this.CurrentImg ++
          currentimg[0].style.marginLeft = -this.CurrentImg * this.bannerwidth + 'px'
        }
        else{
          currentimg[0].style.marginLeft = -this.CurrentImg * this.bannerwidth + 'px'
        }
      }
      else if(this.MoveLength < 0 && this.CurrentImg !== 0){
        if(-this.MoveLength > this.bannerwidth * 0.4){
          this.CurrentImg --
          currentimg[0].style.marginLeft = -this.CurrentImg * this.bannerwidth + 'px'
        }
        else{
          currentimg[0].style.marginLeft = -this.CurrentImg * this.bannerwidth + 'px'
        }
      }
    },
    //slidings()方法用于处理在滑动过程中，轮播图跟着手指滑动的距离移动
    slidings(){
      //判断是点击还是滑动
      if(this.StartPoint === this.EndPoint){return}
      this.MoveLength = this.StartPoint - this.EndPoint
      //操作DOM，获取轮播图对象标签
      const currentimg = document.getElementsByClassName('slide')
      //获取轮播图的宽度
      this.bannerwidth = currentimg[0].offsetWidth
      //判断是否超出滑动范围，即第一页无法再往前一页滑动，最后一页无法再往后一页滑动
      if(this.MoveLength > 0 && this.CurrentImg !== this.dataList.length-1){
        currentimg[0].style.marginLeft = -this.MoveLength - this.CurrentImg * this.bannerwidth   + 'px'
      }
      else if(this.MoveLength < 0 && this.CurrentImg !== 0){
        currentimg[0].style.marginLeft = -this.MoveLength - this.CurrentImg * this.bannerwidth   + 'px'
      }
    },
    //开启轮播
    startPlay() {
      clearInterval(this.playTimer)
      this.playTimer = setInterval(() => {
        if(this.CurrentImg === 2) {
          this.CurrentImg = -1
        }
        this.CurrentImg ++
        const currentimg = document.getElementsByClassName('slide')
        this.bannerwidth = currentimg[0].offsetWidth
        currentimg[0].style.marginLeft = -this.CurrentImg * this.bannerwidth + 'px'
        currentimg[0].style.transition = 'all 1s ease'
      }, 3000)
    }
  }
}
</script>

<style scoped>

.container{
  /*border: 1px solid  #003677 ;*/
  position: relative;
  top: 80px;
  width: 96%;
  margin-left: 2%;
  border: 1px solid #2e5c9a;
  /*padding: 20px;*/
  /*padding: 10px;*/
}

.inContainer{
  width: 90%;
  margin-left: 5%;
}

.content{
  font-size: 14px;
  line-height: 26px;
  margin: 0;
  color: #555555;
  text-align: left;
  text-indent:2em;
}
.footer{
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #003677 ;
  /* font-family: "Microsoft YaHei"; */
  font-weight: normal;
}

.footerBtn{
  color: white;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/pages/pc/index.vue